import { differenceInCalendarDays } from '@crehana/date';

/**
 * Days left before the track expires. Negative means the track is overdue.
 *
 * The `+ 1` offset is deliberate and comes from the original view code: the
 * end date counts as a full day the user still has, so a track whose end date
 * was yesterday returns 0 and is NOT overdue yet. The first overdue value
 * appears two calendar days after the end date.
 */
export const getOverdueDays = (expirationDate: Date | undefined): number => {
  if (!expirationDate) {
    return 0;
  }

  return differenceInCalendarDays(expirationDate, new Date()) + 1;
};

/** A track with no end date never expires. */
export const isTrackExpired = (expirationDate: Date | undefined): boolean =>
  getOverdueDays(expirationDate) < 0;

/**
 * A route stops accepting progress for two independent reasons: an admin
 * closed it, or its end date passed. Both block the course cards, so the
 * consumers only ever need this single derived flag.
 */
export const isRouteClosed = (
  isClosed: boolean,
  expirationDate: Date | undefined,
): boolean => isClosed || isTrackExpired(expirationDate);
